import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/views/terms-and-conditions/index.js");
